import { contactData } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full px-4 md:px-6 lg:px-12 py-12 md:py-16 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 mb-4">{contactData.title}</h2>
        <p className="text-sm text-foreground-500 mb-8">{contactData.subtitle}</p>
        <div className="bg-background-50 rounded-xl border border-background-200/70 p-6 md:p-8 max-w-2xl">
          <p className="text-sm text-foreground-600 leading-relaxed mb-6">{contactData.description}</p>
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-10">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-mail-line text-lg text-primary-500"></i>
              </div>
              <div>
                <span className="text-xs text-foreground-400 block">邮箱</span>
                <span className="text-sm font-medium text-foreground-800">{contactData.email}</span>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-wechat-line text-lg text-accent-500"></i>
              </div>
              <div>
                <span className="text-xs text-foreground-400 block">微信</span>
                <span className="text-sm font-medium text-foreground-800">{contactData.wechat}</span>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-secondary-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-qq-line text-lg text-secondary-500"></i>
              </div>
              <div>
                <span className="text-xs text-foreground-400 block">QQ</span>
                <span className="text-sm font-medium text-foreground-800">{contactData.qq}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}